import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import AreaTitle from '../../../components/areaTitle/AreaTitle';
import AuditTable from './components/AuditTable';
import useAdminAudit from './hooks/useAdminAudit';

/**
 * AdminAudit - Log de auditoria de ações administrativas (Admin Geral)
 *
 * Responsabilidades:
 * - Consome useAdminAudit() para a lista paginada/filtrada de platform_admin_audit_log
 * - Renderiza AreaTitle + estatísticas (total / últimas 24h) + tabela filtrável, com
 *   os filtros vivendo na URL para que o link possa ser compartilhado
 */
function AdminAudit() {
  const {
    entries,
    pagination,
    actions,
    summary,
    isLoading,
    error,

    action,
    setAction,
    companyInput,
    setCompanyInput,
    searchInput,
    setSearchInput,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    setPage,
  } = useAdminAudit();

  return (
    <Box sx={{ backgroundColor: '#F8F9FC', minHeight: '100vh', p: { xs: 2, md: 3 } }}>
      <Box sx={{ mb: 3 }}>
        <AreaTitle
          Title="Admin Geral · Auditoria"
          Icon={<HistoryOutlinedIcon />}
          Description="Ações administrativas registradas na plataforma: quem fez o quê, em qual empresa e quando."
        />
      </Box>

      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Registros: <strong>{summary.total}</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Últimas 24h: <strong>{summary.last_24h}</strong>
        </Typography>
      </Box>

      <AuditTable
        entries={entries}
        isLoading={isLoading}
        error={error}
        pagination={pagination}
        onPageChange={setPage}
        filters={{
          actions,
          action,
          onActionChange: setAction,
          companyInput,
          onCompanyInputChange: setCompanyInput,
          searchInput,
          onSearchInputChange: setSearchInput,
          dateFrom,
          onDateFromChange: setDateFrom,
          dateTo,
          onDateToChange: setDateTo,
        }}
      />
    </Box>
  );
}

export default AdminAudit;
